export enum EExoticMeasure {
    Lingette = 5,
    Massif = 6,
    Eau = 7,
    AdductionAir = 8
}